import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import {
  EventqDialogPopover,
  EventqDialogPopoverPlacement,
} from '../dialog-popover/dialog-popover';

@Component({
  selector: 'eventq-arm-site-popover',
  imports: [MatIcon, EventqDialogPopover],
  templateUrl: './arm-site-popover.html',
  styleUrl: './arm-site-popover.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventqArmSitePopover {
  readonly open = input(false);
  readonly siteName = input.required<string>();
  readonly submitDisabled = input(false);
  readonly cancelLabel = input('Cancel');
  readonly confirmLabel = input('Arm Site');
  readonly title = input('Arm Site');
  readonly question = input('Do you want to arm this site?');
  readonly anchor = input<HTMLElement | null>(null);
  readonly placement = input<EventqDialogPopoverPlacement | 'auto'>('auto');
  readonly panelWidth = input<string | null>('420px');

  readonly closed = output<void>();
  readonly confirm = output<void>();

  readonly resolvedPlacement = computed((): EventqDialogPopoverPlacement => {
    const placement = this.placement();
    if (placement !== 'auto') {
      return placement;
    }

    return this.anchor() ? 'anchor-top-end' : 'center';
  });

  onConfirm(): void {
    if (this.submitDisabled()) {
      return;
    }

    this.confirm.emit();
  }
}
